<template>
    <div class="promotion-panel basics-panel">
        <div class="panel-heading">
            <div>
                <h2>学校与宿舍楼</h2>
                <p>学校和宿舍楼只允许停用，停用后不会再出现在楼长任命选项中。</p>
            </div>
            <div class="heading-actions">
                <el-button type="warning" icon="el-icon-plus" @click="openSchoolDialog">新增学校</el-button>
                <el-button plain icon="el-icon-plus" @click="openBuildingDialog" :disabled="!schools.length">新增宿舍楼</el-button>
            </div>
        </div>

        <el-row :gutter="20">
            <el-col :md="11" :sm="24">
                <div class="section-card">
                    <div class="section-title">
                        <span>学校列表</span>
                        <el-select v-model="schoolStatus" size="mini" @change="loadSchools">
                            <el-option label="启用" :value="1" />
                            <el-option label="停用" :value="0" />
                            <el-option label="全部" :value="''" />
                        </el-select>
                    </div>
                    <el-table v-loading="schoolLoading" :data="schools" stripe empty-text="暂无学校">
                        <el-table-column prop="name" label="学校名称" min-width="150" />
                        <el-table-column label="状态" width="85">
                            <template slot-scope="scope">
                                <el-tag :type="isEnabled(scope.row) ? 'success' : 'info'" size="mini">
                                    {{ isEnabled(scope.row) ? '启用' : '停用' }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="90">
                            <template slot-scope="scope">
                                <el-button
                                    v-if="isEnabled(scope.row)"
                                    type="text"
                                    class="danger-text"
                                    @click="disableSchool(scope.row)">
                                    停用
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-col>

            <el-col :md="13" :sm="24">
                <div class="section-card">
                    <div class="section-title">
                        <span>宿舍楼列表</span>
                        <div class="building-filters">
                            <el-select v-model="selectedSchoolId" size="mini" placeholder="选择学校" @change="loadBuildings">
                                <el-option
                                    v-for="school in schools"
                                    :key="school.schoolId || school.id"
                                    :label="school.name"
                                    :value="school.schoolId || school.id" />
                            </el-select>
                            <el-select v-model="buildingStatus" size="mini" @change="loadBuildings">
                                <el-option label="启用" :value="1" />
                                <el-option label="停用" :value="0" />
                                <el-option label="全部" :value="''" />
                            </el-select>
                        </div>
                    </div>
                    <el-table v-loading="buildingLoading" :data="buildings" stripe empty-text="请选择学校">
                        <el-table-column prop="name" label="宿舍楼名称" min-width="150" />
                        <el-table-column label="状态" width="85">
                            <template slot-scope="scope">
                                <el-tag :type="isEnabled(scope.row) ? 'success' : 'info'" size="mini">
                                    {{ isEnabled(scope.row) ? '启用' : '停用' }}
                                </el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="90">
                            <template slot-scope="scope">
                                <el-button
                                    v-if="isEnabled(scope.row)"
                                    type="text"
                                    class="danger-text"
                                    @click="disableBuilding(scope.row)">
                                    停用
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-col>
        </el-row>

        <el-dialog title="新增学校" :visible.sync="schoolDialogVisible" width="420px" @closed="resetSchoolForm">
            <el-form ref="schoolForm" :model="schoolForm" :rules="schoolRules" label-width="90px">
                <el-form-item label="学校名称" prop="name">
                    <el-input v-model.trim="schoolForm.name" maxlength="80" clearable />
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="schoolDialogVisible = false">取消</el-button>
                <el-button type="warning" :loading="saving" @click="createSchool">保存</el-button>
            </span>
        </el-dialog>

        <el-dialog title="新增宿舍楼" :visible.sync="buildingDialogVisible" width="420px" @closed="resetBuildingForm">
            <el-form ref="buildingForm" :model="buildingForm" :rules="buildingRules" label-width="90px">
                <el-form-item label="所属学校" prop="schoolId">
                    <el-select v-model="buildingForm.schoolId" placeholder="请选择学校" style="width: 100%">
                        <el-option
                            v-for="school in enabledSchools"
                            :key="school.schoolId || school.id"
                            :label="school.name"
                            :value="school.schoolId || school.id" />
                    </el-select>
                </el-form-item>
                <el-form-item label="宿舍楼名称" prop="name">
                    <el-input v-model.trim="buildingForm.name" maxlength="80" clearable />
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="buildingDialogVisible = false">取消</el-button>
                <el-button type="warning" :loading="saving" @click="createBuilding">保存</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import request from "@/tool/request";
import API from "@/tool/api";
import {
    asList,
    getResultMessage,
    isResultSuccess,
} from "@/tool/result";

export default {
    data() {
        return {
            schools: [],
            buildings: [],
            schoolStatus: 1,
            buildingStatus: 1,
            selectedSchoolId: "",
            schoolLoading: false,
            buildingLoading: false,
            saving: false,
            schoolDialogVisible: false,
            buildingDialogVisible: false,
            schoolForm: { name: "" },
            buildingForm: { schoolId: "", name: "" },
            schoolRules: {
                name: [{ required: true, message: "请输入学校名称", trigger: "blur" }],
            },
            buildingRules: {
                schoolId: [{ required: true, message: "请选择所属学校", trigger: "change" }],
                name: [{ required: true, message: "请输入宿舍楼名称", trigger: "blur" }],
            },
        };
    },
    computed: {
        enabledSchools() {
            return this.schools.filter((school) => this.isEnabled(school));
        },
    },
    mounted() {
        this.loadSchools();
    },
    methods: {
        isEnabled(item) {
            return item && (item.status === 1 || item.status === "1" || item.enabled === true);
        },
        idOf(item, key) {
            return item && (item[key] || item.id);
        },
        loadSchools() {
            this.schoolLoading = true;
            const params = {};
            if (this.schoolStatus !== "") params.status = this.schoolStatus;
            request.get(API.promotion.schools.list, { params })
                .then((response) => {
                    if (!isResultSuccess(response)) {
                        this.$message.error(getResultMessage(response, "学校列表加载失败"));
                        return;
                    }
                    this.schools = asList(response);
                    const firstEnabled = this.schools.find((school) => this.isEnabled(school));
                    if (!this.selectedSchoolId || !this.schools.some((school) => String(this.idOf(school, "schoolId")) === String(this.selectedSchoolId))) {
                        this.selectedSchoolId = firstEnabled ? this.idOf(firstEnabled, "schoolId") : "";
                    }
                    this.loadBuildings();
                })
                .catch((error) => this.$message.error(getResultMessage(error, "学校列表加载失败")))
                .finally(() => {
                    this.schoolLoading = false;
                });
        },
        loadBuildings() {
            if (!this.selectedSchoolId) {
                this.buildings = [];
                return;
            }
            this.buildingLoading = true;
            const params = { schoolId: this.selectedSchoolId };
            if (this.buildingStatus !== "") params.status = this.buildingStatus;
            request.get(API.promotion.buildings.list, { params })
                .then((response) => {
                    if (!isResultSuccess(response)) {
                        this.$message.error(getResultMessage(response, "宿舍楼列表加载失败"));
                        return;
                    }
                    this.buildings = asList(response);
                })
                .catch((error) => this.$message.error(getResultMessage(error, "宿舍楼列表加载失败")))
                .finally(() => {
                    this.buildingLoading = false;
                });
        },
        openSchoolDialog() {
            this.schoolDialogVisible = true;
        },
        openBuildingDialog() {
            this.buildingForm.schoolId = this.selectedSchoolId || (this.enabledSchools[0] && this.idOf(this.enabledSchools[0], "schoolId"));
            this.buildingDialogVisible = true;
        },
        resetSchoolForm() {
            this.schoolForm = { name: "" };
            if (this.$refs.schoolForm) this.$refs.schoolForm.clearValidate();
        },
        resetBuildingForm() {
            this.buildingForm = { schoolId: this.selectedSchoolId || "", name: "" };
            if (this.$refs.buildingForm) this.$refs.buildingForm.clearValidate();
        },
        createSchool() {
            this.$refs.schoolForm.validate((valid) => {
                if (!valid) return;
                this.saving = true;
                request.post(API.promotion.schools.create, this.schoolForm, {
                    headers: { "Content-Type": "application/json" },
                })
                    .then((response) => {
                        if (!isResultSuccess(response)) {
                            this.$message.error(getResultMessage(response, "学校创建失败"));
                            return;
                        }
                        this.$message.success("学校创建成功");
                        this.schoolDialogVisible = false;
                        this.loadSchools();
                    })
                    .catch((error) => this.$message.error(getResultMessage(error, "学校创建失败")))
                    .finally(() => {
                        this.saving = false;
                    });
            });
        },
        createBuilding() {
            this.$refs.buildingForm.validate((valid) => {
                if (!valid) return;
                this.saving = true;
                request.post(API.promotion.buildings.create, this.buildingForm, {
                    headers: { "Content-Type": "application/json" },
                })
                    .then((response) => {
                        if (!isResultSuccess(response)) {
                            this.$message.error(getResultMessage(response, "宿舍楼创建失败"));
                            return;
                        }
                        this.$message.success("宿舍楼创建成功");
                        this.buildingDialogVisible = false;
                        this.loadBuildings();
                    })
                    .catch((error) => this.$message.error(getResultMessage(error, "宿舍楼创建失败")))
                    .finally(() => {
                        this.saving = false;
                    });
            });
        },
        disableSchool(school) {
            this.$confirm("停用后将联动结束该学校下的楼长任职，并使相关推广码失效，是否继续？", "停用学校", {
                type: "warning",
            }).then(() => {
                this.submitDisable(API.promotion.schools.disable(this.idOf(school, "schoolId")), "学校已停用", this.loadSchools);
            }).catch(() => {});
        },
        disableBuilding(building) {
            this.$confirm("停用后将联动结束该宿舍楼下的楼长任职，并使相关推广码失效，是否继续？", "停用宿舍楼", {
                type: "warning",
            }).then(() => {
                this.submitDisable(API.promotion.buildings.disable(this.idOf(building, "buildingId")), "宿舍楼已停用", this.loadBuildings);
            }).catch(() => {});
        },
        submitDisable(url, successMessage, reload) {
            request({ method: "PUT", url })
                .then((response) => {
                    if (!isResultSuccess(response)) {
                        this.$message.error(getResultMessage(response, "停用失败"));
                        return;
                    }
                    this.$message.success(successMessage);
                    reload();
                })
                .catch((error) => this.$message.error(getResultMessage(error, "停用失败")));
        },
    },
};
</script>

<style scoped>
.promotion-panel {
    color: #303133;
}

.panel-heading,
.section-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
}

.panel-heading {
    margin-bottom: 24px;
}

.panel-heading h2 {
    margin: 0;
    font-size: 22px;
}

.panel-heading p {
    margin: 8px 0 0;
    color: #909399;
}

.heading-actions,
.building-filters {
    display: flex;
    gap: 10px;
}

.section-card {
    min-height: 260px;
    padding: 20px;
    margin-bottom: 20px;
    border: 1px solid #ebeef5;
    border-radius: 8px;
}

.section-title {
    padding-bottom: 16px;
    margin-bottom: 4px;
    font-weight: 600;
}

.section-title > span {
    white-space: nowrap;
}

.danger-text {
    color: #f56c6c;
}

@media (max-width: 800px) {
    .panel-heading,
    .section-title {
        display: block;
    }

    .heading-actions,
    .building-filters {
        margin-top: 14px;
    }

    .building-filters .el-select {
        width: 50%;
    }
}
</style>
